import React from "react";
import { Summary } from "store/reducers";

type Props = {
  summary: Summary;
};

export function AllowanceSummary({ summary }: Props) {
  return (
    <div>
      {summary.travel > 0 && <div>Travel: {summary.travel}</div>}
      {summary.on_call_weekday > 0 && <div>On-Call weekday: {summary.on_call_weekday}</div>}
      {summary.on_call_weekend > 0 && <div>On-Call weekend/PH: {summary.on_call_weekend}</div>}
      {summary.call_back_weekday > 0 && <div>Call-Back weekday: {summary.call_back_weekday}</div>}
      {summary.call_back_weekend > 0 && <div>Call-Back weekend/PH: {summary.call_back_weekend}</div>}
    </div>
  );
}
